module.exports = __webpack_public_path__ + "static/img/theme_bg.0de4d54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme_bg.png
// module id = 854
// module chunks = 0